import React from 'react';
import BaseSection from './_shared/BaseSection';
import ExperiencesCards from '../cards/ExperiencesCards';

const ExperiencesSection = ({ id }, ref) => {
    const introduction = () => (
        <>
            {/* Virtual Reality replaces your vision, Augmented Reality (AR) adds to
            it. &nbsp; */}
            Augmented Reality (AR) transforms how you connect with the world around you. &nbsp;
            <span className="text-card-text-color font-normal">
                {/* Our AR technology is designed for free movement, while
                projecting images over wherever your mobile device points at.
                Our app uses your phone's camera to track your surroundings and
                overlay additional information on top of it, on the screen. */}
                FanCollex technology superimposes information on your smartphone 
                screen while the camera tracks your surroundings, giving you 
                freedom to explore new ways of interaction.  
            </span>
        </>
    );

    return (
        <BaseSection
            id={id}
            name="What’s AR?"
            introduction={introduction()}
            iSize="section-text-default"
            iColor="text-card-title-color"
            ref={ref}
        >
            <ExperiencesCards />
        </BaseSection>
    );
};

export default React.forwardRef(ExperiencesSection);
